import { Box, Typography } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { SERVER_URI } from "../../utils/config"

export const ReceivedFeedback = () => {
	const feedbackId = useParams().id
	const [senderName, setSenderName] = useState(null)
	const [senderEmail, setSenderEmail] = useState(null)
	const [message, setMessage] = useState(null)
	const [isLoaded, setIsLoaded] = useState(false)

	useEffect(() => {
		const getFeedback = async () => {
			try {
				const response = await axios.get(`${SERVER_URI}/get_feedback/${feedbackId}`)
				setSenderName(response.data.feedback.name)
				setSenderEmail(response.data.feedback.email)
				setMessage(response.data.feedback.message)
				setIsLoaded(true)
			} catch (error) {
				console.error(error)
			}
		}
		getFeedback()
	}, [isLoaded, feedbackId])

	return (
		<>
			{isLoaded ? (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						mt: 2,
						pl: 2,
						borderStyle: "groove",
						borderRadius: 2,
					}}>
					<Box sx={{ pb: 2 }}>
						<Typography variant="h4">Lähettäjä: {senderName}</Typography>
						<Typography variant="h4">
							Lähettäjän sähköpostiosoite:{" "}
							{
								<a style={{ textDecoration: "none" }} href={`mailto:${senderEmail}`}>
									{senderEmail}
								</a>
							}
						</Typography>
					</Box>
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<Typography variant="h4">Viesti:</Typography>
						<Typography variant="h5" whiteSpace={"pre-wrap"}>
							{message}
						</Typography>
					</Box>
				</Box>
			) : (
				<Box
					sx={{
						m: 2,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}>
					<Typography>Ladataan sisältöä...</Typography>
				</Box>
			)}
		</>
	)
}
